import './App.css';
import 'antd/dist/antd.css';
import AuthContext from './store/AuthContext';
import { useContext } from 'react';
import { Layout, Spin } from 'antd';
import LoadingSpinner from './components/LoadingSpinner';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from './pages/Login';
import MainLayout from './components/Layout/MainLayout';
import ChatContent from './pages/ChatContent';
import initializeMessageConfig from './config/messageConfig';
import NotFound from './pages/NotFound';

initializeMessageConfig();

function App() {
  const authCtx = useContext(AuthContext);
 
  return (
    <>
      {authCtx.displaySpinner && (
        <Layout>
          <Spin indicator={<LoadingSpinner />} spinning={authCtx.displaySpinner}></Spin>
        </Layout>
      )}
      <Switch>
      <Route exact path="/" render={() => <Redirect to="/login" />} />
      <Route exact path="/login" render={() => <NotFound />} />
      <MainLayout>
          {/* <Route path="/chat" exact component={ChatContent} /> */}
          <Route path="/chat/:chatIdentifier?" component={ChatContent} />
      </MainLayout>
      </Switch>
    </>
  );
}

export default App;
